/** */
import React from 'react';
import styles from './insight-list.module.css';

export const InsightList = ({ insights = [], empty = 'No insights' }) => {
  if (!insights || !Array.isArray(insights) || insights.length === 0)
    return <div className={styles.empty}>{empty}</div>;
  return (
    <ul className={styles.list}>
      {insights?.map((item, i) => (
        <li key={i}>{item}</li>
      ))}
    </ul>
  );
};
